export default __webpack_public_path__ + "static/media/cloud-search.361dc4a4.svg";